import { TableProps } from 'antd/es/table/InternalTable';
import { Company } from 'types/data';

export const OrganizationTableProps: TableProps<Company> = {
  bordered: false,
  size: 'large',
  showHeader: true,
  tableLayout: 'auto',
  pagination: false,
  scroll: { x: '100vw' },
  rowSelection: {},
};
